import styled from 'styled-components';
import { space, font, query, color } from '@design/templateFns';

export const Header = styled.h2`
  ${font('headline-xs')};
  text-align: center;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-md')};
  }
`;

export const LocalLogicMap = styled.div`
  margin-bottom: 40px;
  height: 700px;
  width: 100%;
`;

export const LocalLogicSection = styled.div`
  margin-bottom: 60px;
`;

export const Text = styled.p`
  ${font('body-sm')};
  padding: 30px;
  padding-bottom: ${space('md')};
  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md')};
  }
`;
